import { render, staticRenderFns } from "./CandidateViewInfo.vue?vue&type=template&id=20413040&"
import script from "./CandidateViewInfo.vue?vue&type=script&lang=js&"
export * from "./CandidateViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports